import type { TranslationDict } from './ja'

export const nl: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Speluitleg',
  helpAria: 'Speluitleg',
  settings: 'Instellingen',
  settingsAria: 'Instellingen',
  close: 'Sluiten',
  closeAria: 'Sluiten',
  player: 'Speler',
  highscore: 'Highscore',
  start: 'Start spel',
  staminaEmpty: 'Niet genoeg stamina',
  ranking: 'Territoriumstrijd',
  difficultyTitle: 'Kies moeilijkheid',
  difficultyStart: 'Start met deze moeilijkheid',
  back: 'Terug',
  today: 'Vandaag',
  weekly: 'Deze week',
  alltime: 'Totaal',
  loading: 'Laden...',
  noScores: 'Nog geen scores. Word de eerste kampioen!',
  loadFailed: 'Laden mislukt',
  you: 'Jij',
  youConstant: 'JIJ',
  language: 'Taal',
  languageNote: 'Ondersteunt 18 talen, inclusief Japans.',
  bgm: 'Muziek',
  se: 'Geluidseffecten',
  soundEnableAria: 'Geluid aanzetten',
  soundDisableAria: 'Geluid uitzetten',
  adWatch: 'Bekijk advertentie tot het einde',
  adCancel: 'Niet nu',
  rankSuffix: 'e',
  earnedPoints: 'heeft {score} ptn verdiend',
  helpGoalTitle: '🎯 Doel',
  helpGoalText: 'Plaats stukken op het 9x9 bord en breid je verbonden territoria uit. De hoogste score wint.',
  helpWinTitle: '🏆 Wincondities',
  helpWinFive: 'Maak een rij van vijf horizontaal, verticaal of diagonaal voor een directe overwinning.',
  helpWinScore: 'Als het bord vol is, wint de hoogste score. Er zijn geen gelijke spelen.',
  helpScoreTitle: '💯 Scoren',
  helpLineBonus: 'Lijnbonus: verdien punten voor rijen van 3, 4 en 5 stukken.',
  helpClusterBonus: 'Territoriumbonus: score meer naarmate je verbonden groepen groter worden.',
  helpKomi: 'Komi: de tweede speler krijgt een score-handicap van +10%.',
  helpControlsTitle: '🖱️ Besturing',
  helpControlsText: 'Tik tijdens jouw beurt op een leeg vakje om een stuk te plaatsen.',
  helpTipsTitle: '💡 Tips',
  helpTipHell: 'Probeer HELL als je de ultieme uitdaging zoekt.',
  helpTipCluster: 'Jaag niet alleen op rijen van vijf. Grotere verbonden groepen verhogen ook je score.',
  resultWinFive: '🎉 Vijf op een rij! Je hebt gewonnen!',
  resultWinScore: '🎉 Overwinning op score! Je hebt gewonnen!',
  resultLoseFive: '😿 De CPU heeft vijf op een rij!',
  resultLoseScore: '😿 Verloren op score. Probeer het opnieuw!',
  resultDraw: '🤝 Gelijkspel',
  newHighscore: '🏆 Nieuwe highscore!',
  scoreNone: 'Geen score',
  clusterBonus: 'Territoriumbonus',
  retry: 'Opnieuw spelen',
  titleBack: 'Titel',
  scoreHintPlaceStone: 'Plaats een steen',
  best: 'Beste',
  clusterUnit: 'territorium',
  lineCount: '{len} op een rij x{count}',
  turnCount: 'Zet {count} · {difficulty}',
  boardPlayerPiece: 'Jouw stuk',
  boardCpuPiece: 'CPU stuk',
  boardPlayerAlt: 'Jij',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'rij {row}, kolom {col}',
  boardPlaceable: 'plaatsbaar',
  boardEmpty: 'leeg vakje',
  boardFlower: 'heeft bloem',
  firstPlayerAlt: 'Eerste speler',
  playerFirst: 'Jij mag eerst!',
  playerSecond: 'Jij bent tweede (+{bonus}% komi)',
  cpuFirst: 'De CPU mag eerst!',
  finalePlayerWin: 'Je hebt gewonnen!',
  finaleCpuWin: 'CPU heeft gewonnen!',
  finaleFive: 'Vijf op een rij!',
  finaleTerritory: 'Territoriumgevecht!',
  winnerAlt: 'Winnaar',
  loadingBoot: 'Opstarten...',
  loadingConnect: 'Verbinden...',
  loadingProfile: 'Profiel laden...',
  loadingAssets: 'Resources laden...',
  loadingReady: 'Gereed',
  reauthRequiredTitle: 'Inloggen vereist',
  startupFailedTitle: 'Opstarten mislukt',
  reauthButton: 'Opnieuw inloggen',
  reloadButton: 'Herladen',
  lineReloginButton: 'LINE inloggen',
  reauthReason: 'Je inlogsessie is verlopen. Log opnieuw in.',
  errorReauth: 'Je inlogsessie is verlopen. Log opnieuw in.',
  errorForbidden: 'Je hebt geen toestemming om dit spel te spelen.',
  errorNotFound: 'Spelgegevens niet gevonden.',
  errorRateLimited: 'Het netwerk is druk. Wacht even en probeer het opnieuw.',
  errorServer: 'Kan geen verbinding maken met de server. Wacht even en herlaad.',
  errorCommunication: 'Communicatiefout opgetreden. Herlaad de pagina.',
  errorNetwork: 'Kan geen verbinding maken met het netwerk. Controleer je verbinding en herlaad.',
  errorStartup: 'Opstarten mislukt. Herlaad de pagina.',
  settingsTabGeneral: 'Instellingen',
  settingsTabAccount: 'Account',
  settingsTabInfo: 'Info',
  account: 'Account',
  linked: 'Gekoppeld',
  guest: 'Gast',
  loggedInWith: 'Ingelogd via {provider}',
  loggedIn: 'Ingelogd',
  playingAsGuest: 'Je speelt momenteel als gast.',
  appleLoginBusy: 'Inloggen met Apple...',
  appleLogin: 'Inloggen met Apple',
  googleLoginBusy: 'Inloggen met Google...',
  googleLogin: 'Inloggen met Google',
  logoutBusy: 'Uitloggen...',
  logout: 'Uitloggen',
  logoutSuccess: 'Uitgelogd',
  logoutFailed: 'Uitloggen mislukt',
  appInfo: 'App-informatie',
  appName: 'App-naam',
  version: 'Versie',
  legalInfo: 'Juridisch',
  terms: 'Gebruiksvoorwaarden',
  privacy: 'Privacybeleid',
  operator: 'Operator',
  contact: 'Contact',
  copyTap: 'Tik om te kopiëren',
  idCopied: 'ID gekopieerd',
  copyFailed: 'Kopiëren mislukt',
  other: 'Overig',
  reportAd: 'Meld ongepaste advertentie',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Profiel bewerken',
  displayName: 'Weergavenaam',
  displayNamePlaceholder: 'Voer een naam in',
  chooseIcon: 'Kies icoon',
  iconLoadFailed: 'Laden van iconen mislukt.',
  saveFailed: 'Opslaan mislukt. Probeer het opnieuw.',
  noIcons: 'Geen iconen beschikbaar.',
  save: 'Opslaan',
  saving: 'Opslaan...',
  staminaAria: 'Stamina {stamina} / {max}',
  nextRecovery: 'Volgende herstel over {time}',
  adPlaying: 'Advertentie wordt afgespeeld...',
  recoverFullAd: 'Bekijk advertentie voor volledig stamina-herstel',
  dailyBonusAria: 'Bekijk advertentie tot het einde voor +5 stamina',
  dailyBonusAd: 'Bekijk advertentie voor +5 stamina',
  legalLastUpdated: 'Laatst bijgewerkt: {date}',
  privacyTitle: 'Privacybeleid',
  termsTitle: 'Gebruiksvoorwaarden',
  adPlayingAria: 'Advertentie wordt afgespeeld',
  adBadge: '▶ Ad',
  adRemaining: 'Nog {seconds}s',
  adDevHint: 'Testadvertentie. In productie wordt een AdMob-video afgespeeld.',
  adRewardRequirement: 'Bekijk de advertentie tot het einde om deze beloning te ontvangen.',
  adRewardStaminaDetail: 'Beloning: herstel stamina tot het maximum',
  adRewardDailyBonusDetail: 'Beloning: +{amount} stamina als dagelijkse bonus',
  adRewardIncompleteNote: 'Als je eerder sluit, ontvang je geen beloning.',
  adSkipAria: 'Advertentie overslaan',
  adSkip: 'Overslaan ✕',
  adSkipAfter: 'Overslaan over {seconds}s',
  offlineMessage: 'Kan geen verbinding maken met de server. Sommige functies zijn mogelijk niet beschikbaar.',
  reconnecting: 'Opnieuw verbinden...',
  reconnect: 'Opnieuw verbinden',
  signInTitle: 'Inloggen',
  signInBusy: 'Inloggen...',
  signInCancelNote: 'Als je inloggen annuleert, kun je als gast doorgaan (sommige functies beperkt).',
  processing: 'Verwerken...',
  recoverConfirmTitle: 'Bevestig overschrijven gegevens',
  recoverConfirmMessage: 'Er zijn al gegevens gekoppeld aan deze login. Doorgaan zal de gastgegevens op dit apparaat vervangen. Wil je doorgaan?',
  recoverConfirmContinue: 'Herstellen',
  recoverConfirmCancel: 'Annuleren',
  unlinkConfirmTitle: 'Account ontkoppelen',
  unlinkConfirmMessage: 'Als je deze provider ontkoppelt, keert dit apparaat terug naar gast-modus. Je Hub-gegevens blijven beschikbaar als je opnieuw inlogt met dezelfde provider op een ander apparaat.',
  unlinkConfirmContinue: 'Ontkoppelen',
  unlinkConfirmCancel: 'Annuleren',
  deleteConfirmTitle: 'Bevestig verwijderen account',
  deleteConfirmMessage: 'Het verwijderen van je account wist highscores, inloggegevens, gekoppelde accounts en uitnodigingen.\nDeze actie kan niet ongedaan worden gemaakt. Weet je het zeker?',
  deleteConfirmContinue: 'Account verwijderen',
  deleteConfirmCancel: 'Annuleren',
  adNekoTitle: 'AD Neko',
  matchmakingRemaining: 'Nog {seconds}s',
  matchmakingTimeoutMessage: 'Geen tegenstander op tijd gevonden. Probeer het opnieuw.',
  difficultyEasyName: 'Casual',
  difficultyEasyDescription: 'De tegenstander is een beetje afgeleid',
  difficultyNormalName: 'Normaal',
  difficultyNormalDescription: 'De tegenstander maakt soms een foutje',
  difficultyHardName: 'Moeilijk',
  difficultyHardDescription: 'De tegenstander heeft een goed overzicht van het bord',
  difficultyHellName: 'Extreem',
  difficultyHellDescription: 'De tegenstander is sterk en denkt vooruit',
}
